import React, { useState, useEffect } from "react";
import "./slider.scss";

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const data = [
    "https://res.cloudinary.com/dlmgs0z2s/image/upload/v1681138564/slider-photo-3_huuszj.jpg",
    "https://res.cloudinary.com/dlmgs0z2s/image/upload/v1681136413/slider-photo-1_hbwhrj.jpg",
    "https://res.cloudinary.com/dlmgs0z2s/image/upload/v1682610428/slider-v-2_uwdmqi.jpg",
    "https://res.cloudinary.com/dlmgs0z2s/image/upload/v1682610428/slider-v-1_un6du6.jpg",
    "https://res.cloudinary.com/dlmgs0z2s/image/upload/v1723873638/slider-photo-3_huuszj-768px_pogtn9.jpg",
    "https://res.cloudinary.com/dlmgs0z2s/image/upload/v1723873711/slider-photo-1_hbwhrj_1_jqxdwp.jpg"
  ];

  useEffect(() => {
    let intervalId;
    
    // First slide change after 2 seconds
    const firstChange = setTimeout(() => {
      setCurrentSlide((prevSlide) => 1 - prevSlide);
      
      // Subsequent changes every 3.5 seconds
      intervalId = setInterval(
        () => setCurrentSlide((prevSlide) => 1 - prevSlide),
        3500
      );
    }, 2000);
    
    return () => {
      clearTimeout(firstChange);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  return (
      <div className="slider">
          <div
              className="container-1"
              style={{transform: `translateX(-${currentSlide * 100}vw)`}}
          >
              <img src={data[0]} alt="" loading="lazy"/>
              <img src={data[1]} alt="" loading="lazy"/>
          </div>
          <div
              className="container-2"
              style={{transform: `translateX(-${currentSlide * 100}vw)`}}
          >
              <img src={data[2]} alt=""/>
              <img src={data[3]} alt=""/>
          </div>
          <div
              className="container-3"
              style={{transform: `translateX(-${currentSlide * 100}vw)`}}
          >
              <img src={data[4]} alt=""/>
              <img src={data[5]} alt=""/>
          </div>
      </div>
  );
};

export default Slider;
